import { useNavigate } from 'react-router-dom';
import { navigateWithSidebar } from '../utils/sidebarState';

// Dual-purpose component:
// 1) Default (button mode): renders only a back button (legacy usage)
// 2) Layout mode (layout={true}): wraps page content with a professional container + back button
//    preventing accidental wrapping of entire page in a button.
export default function BackWithSidebar({
  to = '/dashboard',
  open = true,
  className = 'p-2 rounded-full hover:bg-gray-100',
  children,
  layout = false,
  showBack = true,
  maxWidth = 'max-w-6xl'
}) {
  const navigate = useNavigate();

  const handleBack = () => {
    navigateWithSidebar(navigate, to, open);
  };

  if (!layout) {
    // Legacy button behavior
    return (
      <button onClick={handleBack} className={className} aria-label="back-with-sidebar">
        {children || (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        )}
      </button>
    );
  }

  return (
    <div className="min-h-screen w-full bg-gray-50">
      <div className={`${maxWidth} mx-auto px-4 sm:px-6 lg:px-8 py-4`}>        
        {showBack && (
          <div className="mb-4">
            <button
              onClick={handleBack}
              className="p-2 rounded-lg hover:bg-white/60 bg-white shadow-sm border border-gray-200 transition"
              aria-label="voltar"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-gray-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
          </div>
        )}
        <main className="pb-10">{children}</main>
      </div>
    </div>
  );
}
